import React from 'react'
import { Navigate } from 'react-router-dom';
import { useSessionStore } from '../hooks/useSessionStore'


/**
 * If the user is an usuario, show the children, otherwise redirect to the login page
 */
export const PrivateUsuario = ({ children }) => {


    /* Using the useSessionStore hook to get the user from the local storage.   usuarioNormal */
    const [Usuario, setUsuario] = useSessionStore({});

    return (Usuario.tipo === "usuarioNormal")
        ? children
        : (Usuario.tipo === undefined)
            ? <Navigate to="/" />
            : (Usuario.tipo === "noRegistrado")
                ? <Navigate to="/" />
                : (Usuario.tipo === "usuarioEmpresa")
                    ? <Navigate to="/miEmpresa" />
                    : (Usuario.tipo === "usuarioAdmin")
                    && <Navigate to="/Usuarios" />

}